module.exports = __webpack_public_path__ + "fonts/PFDinTextCondPro-Regular.ac54ae3f.ttf";